// extracted by mini-css-extract-plugin
module.exports = {"MapaTitol":"VisualitzacioLiniaTemporalData_MapaTitol__7-fuN"};